export default __webpack_public_path__ + "fdd6cf0b7ab72022cef3de8213ca29bf.png";